import React from "react";
import { ProductGridViewItem } from "./components/product-grid-view-item";
import { NoContentMessage } from "../no_content_message";
import { ColumnShimmerX5 } from "../shimmer/shimmer_types";
export function ProductGridView(props) {
    const { products, isLoading } = props;
    return isLoading ? (React.createElement("div", { className: "flex flex-col gap-8 w-full" },
        React.createElement(ColumnShimmerX5, { amountOfColumns: 3 }),
        React.createElement(ColumnShimmerX5, { amountOfColumns: 3 }),
        React.createElement(ColumnShimmerX5, { amountOfColumns: 3 }))) : products.length > 0 ? (React.createElement("form", { className: "flex gap-8" },
        React.createElement("div", { className: "grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 gap-8" }, products?.map((product, index) => (React.createElement(ProductGridViewItem, { key: index, product: product })))))) : (React.createElement(NoContentMessage, { messages: ["No products found"] }));
}
